import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './Skeleton.css';

const TextLine = ({ className }) => (
  <span className={classnames(styles.element, styles.text, className)}>
    &nbsp;
  </span>
);

TextLine.propTypes = {
  /** define a custom className for the skeleton */
  className: PropTypes.string,
};

export default TextLine;
